import ValidatePage from "@/router/modules/methods/validate";
import clear_all_videos from "@/router/modules/methods/clear_all_videos";

export default {
    path: '/calendar',
    name: 'Calendar',
    component: () => import('@/views/calendar/index.vue'),
    meta: {
        title: 'Выбор даты',
        forVisitors: true
    },
    beforeEnter: async (to, from, next) => {
        await clear_all_videos()
        await ValidatePage(next)
    }
}